export default function (){return [
    {icon: 'fa-network-wired', text: 'Overview', to: '/overview'},
    {icon: 'fa-calendar-alt', text: 'Monthly Summary', to: '/executive-summary'},
    {
        icon: 'fa-angle-up',
        'icon-alt': 'fa-angle-down',
        text: 'Config',
        model: false,
        children: [
            {icon: 'fa-users', text: 'Users', to: '/users'},
        ]
    },
    {icon: 'fa-question', text: 'Help', to: '/help'}
]}